import React from "react";
import Contents from "../components/pages/preMatching/Contents";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";

const PreMatching = () => {
  return (
    <>
      <Header />
      <Contents />
      <Footer />
    </>
  );
};

export default PreMatching;
